import { cB, cM } from '../../../_utils/cssr'

export default cB('checkbox', [
  cM('rtl', `
    direction: rtl;
  `)
])
